import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ContractModule } from "./contract/contract.module";
import { SharedModule } from "./shared/shared/shared.module";
import { AuthModule } from "./auth/auth.module";

import { AngularFirestoreModule } from "@angular/fire/compat/firestore";
import { environment } from "../environments/environment";

import { OnboardingModule } from "./onboarding/onboarding.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AngularFireModule } from "@angular/fire/compat";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AuthInterceptor } from "src/auth-intercepter";
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AuthModule,
    AppRoutingModule,
    ContractModule,
    OnboardingModule,
    SharedModule.forRoot(),
    // NgMultiSelectDropDownModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    HttpClientModule,
    BrowserAnimationsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
